import { create } from 'zustand';
import { ContainerPort } from '../types';

interface PortSettingState {
  ports: ContainerPort[];
  validate?: () => Promise<boolean>;
}

const initialState: PortSettingState = {
  ports: [],
};

interface PortSettingActions {
  updatePorts: (ports: ContainerPort[]) => void;
  setValidate: (validate: () => Promise<any>) => void;
  reset: () => void;
}

export const usePortSettingStore = create<PortSettingState & PortSettingActions>()((set) => ({
  ...initialState,
  updatePorts: (ports: ContainerPort[]) => set({ ports }),
  setValidate: (validate) => set({ validate }),
  reset: () => set((state) => ({ ...state, ports: [...initialState.ports] })),
}));
